import type { IEvento } from "@/interfaces/evento.interface";

/** EventoId valido (redux/localStorage pode vir string, 0 ou vazio). */
export function hasValidEventoId(eventoId: unknown): boolean {
  return (
    eventoId != null &&
    eventoId !== "" &&
    Number(eventoId) > 0 &&
    !Number.isNaN(Number(eventoId))
  );
}

export function listFromQueryData(data: unknown): any[] {
  if (Array.isArray(data)) return data;
  if (Array.isArray((data as { data?: unknown })?.data)) {
    return (data as { data: any[] }).data;
  }
  if (Array.isArray((data as { items?: unknown })?.items)) {
    return (data as { items: any[] }).items;
  }
  return [];
}

export function findEventoById(
  list: unknown,
  eventoId: unknown,
): IEvento | undefined {
  if (!hasValidEventoId(eventoId)) return undefined;
  return listFromQueryData(list).find((ev: { Id?: number }) => ev?.Id == eventoId);
}

const EVENTO_QUERY_ENDPOINTS = new Set([
  "getEventos",
  "getEventosPaginated",
  "getEvento",
]);

/** Recupera o evento selecionado do cache RTK quando a lista do slice foi zerada. */
export function findEventoInRtkQueries(
  queries:
    | Record<
        string,
        | {
            endpointName?: string;
            data?: unknown;
            fulfilledTimeStamp?: number;
          }
        | undefined
      >
    | undefined,
  eventoId: unknown,
): IEvento | undefined {
  if (!hasValidEventoId(eventoId) || !queries) return undefined;

  let found: IEvento | undefined;
  let latest = 0;

  for (const query of Object.values(queries)) {
    if (!query?.data || !EVENTO_QUERY_ENDPOINTS.has(query.endpointName ?? "")) {
      continue;
    }

    const fromList = findEventoById(query.data, eventoId);
    const single =
      !fromList && (query.data as { Id?: number })?.Id == eventoId
        ? (query.data as IEvento)
        : undefined;
    const match = fromList ?? single;
    const ts = query.fulfilledTimeStamp ?? 0;
    if (match && ts >= latest) {
      latest = ts;
      found = match;
    }
  }

  return found;
}

/**
 * Se o refetch devolveu uma pagina/filtro sem o evento atual, mantem ele
 * visivel no select — evita o placeholder "selecione um evento" no meio da sessao.
 */
export function mergeSelectedEventoNaLista(
  incoming: Array<IEvento> | null | undefined,
  selected: IEvento | undefined,
  eventoId: unknown,
): IEvento[] {
  const list = Array.isArray(incoming) ? incoming : [];
  if (!selected || !hasValidEventoId(eventoId)) return list;
  if (list.some((ev) => ev.Id == eventoId)) return list;
  return [selected, ...list];
}
